import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    IconComponent,
    ButtonComponent,
  ],
})
export class OrderConfirmationComponent {
}
